import axios from 'axios';
import router from '../router';

const TOKEN_EXPIRED_MSG = 'Token expired';

let isHandlingTokenExpired = false;

/**
 * Registers a global axios response interceptor: on 401 with `{ msg: 'Token expired' }`,
 * clears the session token and navigates to Logout (which clears store and sends user to Login).
 *
 * @returns {void}
 *
 * @created_at 07/04/2026 by AI (gpt-5.2)
 * @changed_at 07/04/2026 by AI (gpt-5.2) — avoid optional chaining for e2e/webpack compatibility
 */
export function registerAxiosTokenExpiredInterceptor() {
	axios.interceptors.response.use(
		(response) => response,
		(error) => {
			const responsePayload = error.response;
			const status = responsePayload && responsePayload.status;
			const data = responsePayload && responsePayload.data;
			const msg = data && data.msg;

			if (status !== 401 || msg !== TOKEN_EXPIRED_MSG) {
				return Promise.reject(error);
			}

			if (isHandlingTokenExpired) {
				return Promise.reject(error);
			}

			const current = router.currentRoute;
			const routeName = current && current.name;
			if (routeName === 'Logout' || routeName === 'Login') {
				return Promise.reject(error);
			}

			isHandlingTokenExpired = true;

			localStorage.removeItem('token');
			delete axios.defaults.headers.common['x-auth-token'];

			router
				.replace({ name: 'Logout' })
				.catch(() => {})
				.finally(() => {
					isHandlingTokenExpired = false;
				});

			return Promise.reject(error);
		}
	);
}
